import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo-name.png";
import waiting from "../assets/waiting.png";
import loading from "../assets/loading.png";
import { useAuth } from "../context/AuthContext";
import { IoIosLogOut } from "react-icons/io";

const SellerWaiting = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  return (
    <div className="flex min-h-screen w-full flex-col items-center p-5">
      {/* Logo */}
      <div className="flex w-full justify-start">
        <img src={logo} alt="Logo" className="h-14 sm:h-16" />
      </div>

      {/* waiting Image */}
      <div className="flex w-full max-w-md flex-1 flex-col items-center justify-center">
        <img
          src={waiting}
          alt="waiting Access"
          className="w-full max-w-xs object-cover sm:max-w-sm"
        />

        {/* Text Content */}
        <div className="mt-4 flex flex-col items-center gap-4 text-center">
          <h2 className="text-lg font-semibold">Waiting for admin approval</h2>
          <img src={loading} alt="" className="w-16" />

          <NavLink
            onClick={logout}
            to="/"
            className="w-full flex items-center justify-center gap-2 rounded-md bg-[#FFAE00] py-2 text-white transition hover:bg-[#E09C00]"
          >
            <IoIosLogOut className="text-xl" />
            <span>Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SellerWaiting;
